import { Link } from "react-router-dom";
import { useT } from "../i18n/I18nProvider";
import NewsletterForm from "./NewsletterForm";
import Logo from "./Logo";

export default function Footer() {
  const { t, lp } = useT();
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2">
          <Logo testid="footer-logo" variant="light" />
          <p className="mt-4 text-sm leading-relaxed max-w-md">
            {t("footer.description")}
          </p>
          <div className="mt-6">
            <NewsletterForm source="footer" compact />
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">{t("footer.sections")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to={lp("/logement")} className="hover:text-white transition">{t("nav.logement")}</Link></li>
            <li><Link to={lp("/cout-de-la-vie")} className="hover:text-white transition">{t("nav.coutDeLaVie")}</Link></li>
            <li><Link to={lp("/demarches")} className="hover:text-white transition">{t("nav.demarches")}</Link></li>
            <li><Link to={lp("/demarches-pays-tiers")} className="hover:text-white transition">Démarches pays tiers</Link></li>
            <li><Link to={lp("/travailler-pologne")} className="hover:text-white transition">{t("nav.travailler")}</Link></li>
            <li><Link to={lp("/entrepreneuriat")} className="hover:text-white transition">{t("nav.entrepreneuriat")}</Link></li>
            <li><Link to={lp("/sante")} className="hover:text-white transition">{t("nav.sante")}</Link></li>
            <li><Link to={lp("/education")} className="hover:text-white transition">{t("nav.education")}</Link></li>
            <li><Link to={lp("/connaissances")} className="hover:text-white transition">Connaissances</Link></li>
            <li><Link to={lp("/blog")} className="hover:text-white transition">Blog</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to={lp("/mentions-legales")} className="hover:text-white transition">{t("footer.mentions")}</Link></li>
            <li><Link to={lp("/confidentialite")} className="hover:text-white transition">{t("footer.privacy")}</Link></li>
            <li><Link to={lp("/cgu")} className="hover:text-white transition">{t("footer.cgu")}</Link></li>
            <li><Link to={lp("/methodologie")} className="hover:text-white transition" data-testid="footer-methodology">{t("footer.methodology")}</Link></li>
            <li><a href="mailto:contact@hejpoland.com" className="hover:text-white transition">contact@hejpoland.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <p>{t("footer.copy", { year: new Date().getFullYear() })}</p>
          <p>{t("footer.disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}
